export const PHONE_NUMBER_REGEX = /\b[+]?[(]?[0-9]{2,6}[)]?[-\s.]?[-\s/.0-9]{3,15}\b/;
export const PLZ_REGEX = /[A-Z0-9 -]{3,}/;
export const CUSTOMER_LEAD_RECORD_TYPE = '01258000000DWRx';
export const DEFAULT_CITY = 'berlin';
export const GET_POSTCODE_REGEXP = /[\d]+[A-Z]*/g;
